const auth = {
  logout: "Logout",
};
export default auth;
